import React from "react";
import { Link } from "react-router-dom";

import styles from "./app.scss";
import { asset } from "../../services";

function Logo({ onClick }) {
  return (
    <div className={styles.logoSection}>
      <Link
        title="Index Oglasi"
        className={`child-center ${styles.logo}`}
        onClick={onClick}
        to="/"
      >
        <img
          alt={"Logo"}
          className="full-width"
          src={asset.getImageUrl("new-logo.svg")}
        />
      </Link>
      <div className={styles.appTitle}>Besplatni, sada i zauvijek.</div>
    </div>
  );
}

Logo.defaultProps = {
  onClick: () => null
};

export default React.memo(Logo);



// WEBPACK FOOTER //
// ./src/containers/App/Logo.tsx